import React, { useEffect, useMemo, useRef } from 'react';
import { AuthType, clearLoginStorage, LoginWithRedirect, persistAuthType } from "@shared/utils/AuthUtils";
import { useMsal } from "@azure/msal-react";
import { useDispatch } from "react-redux";
import { setAuthLoading, setUser } from "@shared/store/auth.duck";
import { isInTeamsApp } from "@shared/utils/TeamsUtils";
import { bootstrapAuth } from '@shared/auth/authMachine.duck';
import { rawUserRequest } from '@shared/services/Auth';
import {
  NotificationMessages,
  parseErrorResponse,
  redirectWithNotification
} from "@shared/models/notification.models";
import { getParameterByName } from "@shared/utils/UrlUtils";
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';
import Colours from '@shared/ui/atoms/Colours';
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';

export function MicrosoftLoginButton() {
  const dispatch = useDispatch();
  const {instance, accounts} = useMsal();
  const timerId = useRef(0);
  const errorNotificationCode = useMemo(() => getParameterByName('not', window.location.href), []);

  const loginWithMsTeams = async () => {
    dispatch(setAuthLoading(true));

    try {
      await (dispatch(bootstrapAuth({ source: 'route-guard' })) as any).unwrap();
      const userResp = await rawUserRequest();
      dispatch(setUser(userResp));
    } finally {
      dispatch(setAuthLoading(false));
    }
  }

  const loginWithMs = async () => {
    try {
      dispatch(setAuthLoading(true));

      if (accounts.length >= 1 && errorNotificationCode !== NotificationMessages.azureLoginFailed) {
        try {
          await (dispatch(bootstrapAuth({ source: 'route-guard' })) as any).unwrap();
          const userResp = await rawUserRequest();
          dispatch(setUser(userResp));
        } catch (ex: any) {
          if (ex.statusCode === 401) {
            redirectWithNotification(parseErrorResponse(ex.message, NotificationMessages.azureLoginFailed), '/login');
          } else {
            await LoginWithRedirect(instance, dispatch, true);
          }
        }
      } else {
        await LoginWithRedirect(instance, dispatch, true);
      }

    } finally {
      dispatch(setAuthLoading(false));
    }
  }

  const onClick = async () => {
    clearLoginStorage();
    persistAuthType(AuthType.Microsoft, dispatch);
    if (await isInTeamsApp()) {
      loginWithMsTeams()
    } else {
      loginWithMs();
    }
  }

  useEffect(() => {
    return () => {
      if (timerId.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        clearTimeout(timerId.current);
      }
    }
  }, []);

  return (
    <>
      <OutlineButton dataTest="outlookLogin"
                     className="login__button"
                     text="login.with-office365"
                     borderColour={Colours.black}
                     click={() => onClick()}
                     fullWidth={true} size={ButtonSize.Large}
                     imageUrl="/assets/icons/microsoft-office-logo.svg"/>
    </>
  )
}

